//export default class Banner {
//   constructor() {  
//     this.$sections = document.querySelectorAll('section.banner');  
//   }
//}
//
//new Banner();